var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11.5 10a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15.5 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMTBDNiAxMC44Mjg0IDUuMzI4NDMgMTEuNSA0LjUgMTEuNUMzLjY3MTU3IDExLjUgMyAxMC44Mjg0IDMgMTBDMyA5LjE3MTU3IDMuNjcxNTcgOC41IDQuNSA4LjVDNS4zMjg0MyA4LjUgNiA5LjE3MTU3IDYgMTBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTExLjUgMTBDMTEuNSAxMC44Mjg0IDEwLjgyODQgMTEuNSAxMCAxMS41QzkuMTcxNTcgMTEuNSA4LjUgMTAuODI4NCA4LjUgMTBDOC41IDkuMTcxNTcgOS4xNzE1NyA4LjUgMTAgOC41QzEwLjgyODQgOC41IDExLjUgOS4xNzE1NyAxMS41IDEwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xNS41IDExLjVDMTYuMzI4NCAxMS41IDE3IDEwLjgyODQgMTcgMTBDMTcgOS4xNzE1NyAxNi4zMjg0IDguNSAxNS41IDguNUMxNC42NzE2IDguNSAxNCA5LjE3MTU3IDE0IDEwQzE0IDEwLjgyODQgMTQuNjcxNiAxMS41IDE1LjUgMTEuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgMore20 as ReactComponent };